"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.audioPlay = void 0;
var util_1 = require("./util");
var audioPlay = function (event) {
    return (0, util_1.audioEvent)(event, "audio-play");
};
exports.audioPlay = audioPlay;
